<template>
  <div id="app">
    <svg viewBox="0 0 1000 1000" @click="show.dial = !show.dial">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="16" result="blur"/>
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 15 -4" result="goo" />
        </filter>
      </defs>
      <g class="circles">
        <circle class="dial" v-for="i in 12" :key="i" :cx="computeX((i - 1) / 12, 0.8)" :cy="computeY((i - 1) / 12, 0.8)" r="50" :fill="scale((i - 1) / 12.0)"/>
        <circle class="hour" :cx="computeX((clock.hours) / 12, 0.5)" :cy="computeY((clock.hours) / 12, 0.5)" r="120" :fill="hourColor"/>
        <circle class="minute" :cx="computeX((clock.minutes) / 60, 0.7)" :cy="computeY((clock.minutes) / 60, 0.7)" r="70" :fill="scale((clock.minutes - 1) / 60.0)"/>
        <circle class="second" :cx="computeX((clock.seconds + 1) / 60, 0.9)" :cy="computeY((clock.seconds + 1) / 60, 0.9)" r="40"/>
      </g>
      <text v-show="show.dial" class="txt dial-text" v-for="i in 12" :key="'t'+i" :x="computeX((i - 1) / 12, 0.8)" :y="computeY((i - 1) / 12, 0.8)" fill="black" @click="show.dial = !show.dial">{{num(i)}}</text>
      <g class="sec" :style="{transform: 'translate('+(computeX((clock.seconds + 1) / 60, 0.9)-500)+'px,'+(computeY((clock.seconds + 1) / 60, 0.9)-25)+'px)'}">
        <text v-show="show.dial" class="txt second-text" :x="500" :y="25" fill="white">{{clock.secondsDisplay}}</text>
      </g>
    
      <text v-show="show.dial" class="txt hour-text" :x="computeX((clock.hours) / 12, 0.5)" :y="computeY((clock.hours) / 12, 0.5)" :class="{'is-dark' : isDark(hourColor)}">{{clock.hoursDisplay}}</text>
      <text v-show="show.dial" class="txt minute-text" :x="computeX((clock.minutes) / 60, 0.7)" :y="computeY((clock.minutes) / 60, 0.7)" :class="{'is-dark' : isDark(scale((clock.minutes - 1) / 60.0))}">{{clock.minutesDisplay}}</text>
    </svg>
    <div class="colofon">by <a href="//twitter.com/anneveling">Anne Veling</a></div>
  </div>
</template>

<script>
import Chroma from 'chroma-js'

let pad2 = (n) => n < 10 ? '0' + n : n

export default {
  name: "app",
  data () {
    return {
      clock: {
        seconds: 0,
        minutes: 0,
        hours: 0,
        hoursDisplay: '',
        minutesDisplay: '',
        secondsDisplay: ''
      },
      show: {
        dial: true
      },
      scale: Chroma.scale('Spectral')
    }
  },
  computed: {
    hourColor () {
      let h = this.clock.hours + this.clock.minutes / 60.0 + 6.0
      let hh = h > 12 ? h - 12 : h
      return this.scale(hh / 12.0)
    }
  },
  mounted () {
    this.updateTime()
    this.$options.interval = setInterval(this.updateTime, 1000)
  },
  beforeDestroy () {
    clearInterval(this.$options.interval)
  },
  methods: {
    num (i) {
      return ['XII','I','II','III','IV','V','VI','VII','VIII','IX','X','XI'][i - 1]
    },
    computeX (ratio, radius) {
      let angle = (ratio - 0.25) * Math.PI * 2.0
      return 500 + radius * 500 * Math.cos(angle)
    },
    computeY (ratio, radius) {
      let angle = (ratio - 0.25) * Math.PI * 2.0
      return 500 + radius * 500 * Math.sin(angle)
    },
    updateTime () {
      let now = new Date()

      this.clock = {
        hours: now.getHours() % 12,
        minutes: now.getMinutes(),
        seconds: now.getSeconds(),
        hoursDisplay: now.getHours(),
        minutesDisplay: pad2(now.getMinutes()),
        secondsDisplay: pad2(now.getSeconds())
      }
    },
    isDark (c) {
      return Chroma(c).get('lab.l') < 70
    }
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}
.colofon {
  position: absolute;
  color: white;
  right: 4px;
  bottom: 4px; 
  font-size: 20px;
  a {
    color: rgb(255,255,191);
    text-decoration: none;
  }
}
svg {
  width: 100%;
  height: 100%;
  background-color: black;
  cursor: pointer;
}
.circles {
  filter: url('#goo')
}
.hour {
  transition: all 1s ease-in-out;
}
.second {
  fill: white;
  transition: all 1s ease-in-out;
}
.minute {
  transition: all 1s ease-in-out;
}
.sec {
  transition: all 1s ease-in-out;
}
.txt {
  font-family: 'PT Serif', serif;
  fill: black;
  text-anchor: middle;
  dominant-baseline: middle;
  &.is-dark {
    fill: white;
  }
}
.dial-text {
  font-size: 40px;
  fill: black;
}
.hour-text {
  font-size: 80px;
}
.second-text {
  font-size: 30px;
  fill: black;
  transition: all 1s ease-in-out;
}
.minute-text {
  font-size: 50px;
}
</style>
